var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "row pt-3 l-m-b-20" }, [
        _vm._m(0),
        _vm._v(" "),
        _vm.$_can("carriers.trucks.store")
          ? _c("div", { staticClass: "col-3 text-right" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-primary",
                  on: {
                    click: function($event) {
                      _vm.showCreateSidebar = !_vm.showCreateSidebar
                    }
                  }
                },
                [_vm._v("\n        ADD TRUCK\n      ")]
              )
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12 l-m-b-20" }, [
          _c("div", { staticClass: "input-group search" }, [
            _c(
              "button",
              {
                staticClass: "btn input-group-btn",
                attrs: { type: "button" },
                on: { click: _vm.clearSearch }
              },
              [_c("i", { class: [_vm.q ? "fa fa-remove" : "fa fa-search"] })]
            ),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.q,
                  expression: "q"
                }
              ],
              staticClass: "form-control",
              attrs: { type: "text", placeholder: "Search" },
              domProps: { value: _vm.q },
              on: {
                keyup: function($event) {
                  _vm.searchText($event)
                },
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.q = $event.target.value
                }
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-12 filters-field" }, [
          _c("span", [_vm._v("Filters:")]),
          _vm._v(" "),
          _vm.filtersLoaded
            ? _c("span", [
                _vm.filters.carrier.length && _vm.carriers
                  ? _c(
                      "span",
                      _vm._l(_vm.filters.carrier, function(carrier) {
                        return _c(
                          "span",
                          {
                            key: carrier,
                            staticClass: "filter-item btn btn-filter"
                          },
                          [
                            _c("span", {
                              staticClass: "mod-icon-filter",
                              on: {
                                click: function($event) {
                                  _vm.removeFilter("carrier", carrier)
                                }
                              }
                            }),
                            _vm._v(
                              "\n            Carrier: " +
                                _vm._s(
                                  _vm.carriers.find(function(el) {
                                    return el.id === carrier
                                  }).name
                                )
                            )
                          ]
                        )
                      })
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.filters.status
                  ? _c("span", { staticClass: "filter-item btn btn-filter" }, [
                      _c("span", {
                        staticClass: "mod-icon-filter",
                        on: {
                          click: function($event) {
                            _vm.removeFilter("status")
                          }
                        }
                      }),
                      _vm._v(
                        "\n          Status: " +
                          _vm._s(
                            _vm.truckStatuses.find(function(el) {
                              return el.id === _vm.filters.status
                            }).name
                          )
                      )
                    ])
                  : _vm._e()
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-secondary add-filters",
              on: {
                click: function($event) {
                  _vm.showFilters = true
                }
              }
            },
            [_c("i", { staticClass: "fa fa-plus filter-icon" })]
          )
        ])
      ]),
      _vm._v(" "),
      !_vm.trucks
        ? [
            _c(
              "vue-content-loading",
              { attrs: { width: 800, height: 450 } },
              _vm._l(15, function(x) {
                return _c("rect", {
                  key: x,
                  attrs: {
                    x: "10",
                    y: 15 * x * 1.4,
                    rx: "5",
                    ry: "5",
                    width: "720",
                    height: "6"
                  }
                })
              })
            )
          ]
        : [
            _c("table", { staticClass: "table m-table table-hover l-m-t-20" }, [
              _c("thead", { staticClass: "m-table__heading" }, [
                _c("tr", [
                  _c("th", { staticClass: "m-table__id" }, [_vm._v("ID")]),
                  _vm._v(" "),
                  _c(
                    "th",
                    {
                      staticClass: "sortable",
                      class: { active: _vm.sortKey === "name" },
                      on: {
                        click: function($event) {
                          _vm.sortBy("name")
                        }
                      }
                    },
                    [
                      _vm._v("\n            Name\n            "),
                      _c("span", {
                        staticClass: "arrow",
                        class: _vm.sortOrders["name"] ? "dsc" : "asc"
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "th",
                    {
                      staticClass: "sortable",
                      class: { active: _vm.sortKey === "licence_plate" },
                      on: {
                        click: function($event) {
                          _vm.sortBy("licence_plate")
                        }
                      }
                    },
                    [
                      _vm._v("\n            Licence plate\n            "),
                      _c("span", {
                        staticClass: "arrow",
                        class: _vm.sortOrders["licence_plate"] ? "dsc" : "asc"
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "th",
                    {
                      staticClass: "sortable",
                      class: { active: _vm.sortKey === "truck_size_id" },
                      on: {
                        click: function($event) {
                          _vm.sortBy("truck_size_id")
                        }
                      }
                    },
                    [
                      _vm._v("\n            Truck size\n            "),
                      _c("span", {
                        staticClass: "arrow",
                        class: _vm.sortOrders["truck_size_id"] ? "dsc" : "asc"
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "th",
                    {
                      staticClass: "sortable",
                      class: { active: _vm.sortKey === "make" },
                      on: {
                        click: function($event) {
                          _vm.sortBy("make")
                        }
                      }
                    },
                    [
                      _vm._v("\n            Make\n            "),
                      _c("span", {
                        staticClass: "arrow",
                        class: _vm.sortOrders["make"] ? "dsc" : "asc"
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "th",
                    {
                      staticClass: "sortable",
                      class: { active: _vm.sortKey === "model" },
                      on: {
                        click: function($event) {
                          _vm.sortBy("model")
                        }
                      }
                    },
                    [
                      _vm._v("\n            Model\n            "),
                      _c("span", {
                        staticClass: "arrow",
                        class: _vm.sortOrders["model"] ? "dsc" : "asc"
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c("th", [_vm._v("Status")])
                ])
              ]),
              _vm._v(" "),
              _c(
                "tbody",
                [
                  _vm._l(_vm.trucks, function(truck) {
                    return _c(
                      "tr",
                      {
                        key: truck.id,
                        staticClass: "pointer",
                        on: {
                          mouseup: function($event) {
                            _vm.$_can("carriers.trucks.show") &&
                              _vm.view($event, truck.id)
                          }
                        }
                      },
                      [
                        _c("td", [_vm._v(_vm._s(truck.id))]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(truck.name))]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(truck.licence_plate))]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(truck.truck_size.name))]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(truck.make))]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(truck.model))]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(truck.status.name))])
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _vm.trucks && !_vm.trucks.length
                    ? _c("tr", [
                        _c(
                          "td",
                          {
                            staticClass: "text-center",
                            attrs: { colspan: "7" }
                          },
                          [_vm._v("\n            No results found\n          ")]
                        )
                      ])
                    : _vm._e()
                ],
                2
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "row" },
              [
                _vm.meta.total
                  ? _c("div", { staticClass: "col-sm-6 mb-1 text-black-50" }, [
                      _vm._v(
                        "\n        Showing " +
                          _vm._s(_vm.meta.from) +
                          " - " +
                          _vm._s(_vm.meta.to) +
                          " of " +
                          _vm._s(_vm.meta.total) +
                          "\n      "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("pagination", {
                  staticClass: "col-sm-6 mb-1",
                  attrs: { "change-page": _vm.changePage, meta: _vm.meta }
                })
              ],
              1
            )
          ],
      _vm._v(" "),
      _c("transition", { attrs: { name: "slide-fade" } }, [
        _vm.showFilters
          ? _c(
              "div",
              {
                staticClass: "l-modal-mask",
                on: {
                  click: function($event) {
                    if ($event.target !== $event.currentTarget) {
                      return null
                    }
                    _vm.showFilters = false
                  }
                }
              },
              [
                _vm.showFilters
                  ? _c(
                      "div",
                      { staticClass: "filters-side-modal flex flex-column" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "pointer",
                            on: {
                              click: function($event) {
                                _vm.showFilters = !_vm.showFilters
                              }
                            }
                          },
                          [
                            _c("h1", { staticClass: "modal-h1 l-m-b-20" }, [
                              _c("span", { staticClass: "btn btn-back" }),
                              _vm._v("Add Filter")
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", [
                          _c("p", [
                            _vm._v(
                              "\n            Filters are applied automatically. You can remove them one by one with minus button or with clear filters button.\n          "
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "l-bg-white" }, [
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col" }, [
                              _c("div", { staticClass: "row filters" }, [
                                _vm.carriers && _vm.carriers.length
                                  ? _c("div", { staticClass: "col-12" }, [
                                      _c(
                                        "div",
                                        { staticClass: "select-wrap" },
                                        [
                                          _c("label", [_vm._v("Carrier")]),
                                          _vm._v(" "),
                                          _c("key-multiselect", {
                                            attrs: {
                                              options: _vm.carriers,
                                              multiple: true,
                                              "clear-on-select": false,
                                              "close-on-select": false,
                                              "hide-selected": true,
                                              id: "carrier-select",
                                              placeholder: "Select Carriers",
                                              "preserve-search": false,
                                              label: "name",
                                              "track-by": "id"
                                            },
                                            on: { input: _vm.search },
                                            scopedSlots: _vm._u([
                                              {
                                                key: "tag",
                                                fn: function(props) {
                                                  return [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "multiselect__tag"
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              props.option.name
                                                            )
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("span", {
                                                          staticClass:
                                                            "multiselect__tag-icon",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              props.remove(
                                                                props.option
                                                              )
                                                            }
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  ]
                                                }
                                              }
                                            ]),
                                            model: {
                                              value: _vm.filters.carrier,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.filters,
                                                  "carrier",
                                                  $$v
                                                )
                                              },
                                              expression: "filters.carrier"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-12" }, [
                                  _c(
                                    "div",
                                    { staticClass: "select-wrap" },
                                    [
                                      _c("label", [_vm._v("Status")]),
                                      _vm._v(" "),
                                      _c("simple-select", {
                                        attrs: {
                                          options: _vm.truckStatuses,
                                          placeholder: "Select Status"
                                        },
                                        on: { input: _vm.search },
                                        model: {
                                          value: _vm.filters.status,
                                          callback: function($$v) {
                                            _vm.$set(_vm.filters, "status", $$v)
                                          },
                                          expression: "filters.status"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ])
                              ])
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "row mt-auto" }, [
                          _c("div", { staticClass: "col" }, [
                            !(
                              !_vm.filters.carrier.length && !_vm.filters.status
                            )
                              ? _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-not-active text-dark w-100",
                                    attrs: { type: "button" },
                                    on: { click: _vm.clearFilters }
                                  },
                                  [
                                    _vm._v(
                                      "\n              Clear filters\n            "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ])
                        ])
                      ]
                    )
                  : _vm._e()
              ]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "slide-fade" } }, [
        _vm.showCreateSidebar
          ? _c(
              "div",
              {
                staticClass: "l-modal-mask",
                on: {
                  click: function($event) {
                    if ($event.target !== $event.currentTarget) {
                      return null
                    }
                    _vm.showCreateSidebar = false
                  }
                }
              },
              [
                _c("trucks-create", {
                  staticClass: "sidebar-right",
                  on: {
                    cancel: function($event) {
                      _vm.showCreateSidebar = false
                    },
                    update: _vm.getTrucks
                  }
                })
              ],
              1
            )
          : _vm._e()
      ])
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-9" }, [_c("h1", [_vm._v("Trucks")])])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-75a5972f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75a5972f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/trucks/Trucks.vue
// module id = null
// module chunks = 